<template>
  <q-page class="page">
    <div class="row">
      <q-select
              v-model="mapProvider"
              float-label="Karten Provider"
              :options="mapProviderSelection"
      />
      &nbsp&nbsp
      <q-select
              v-show="mapProvider == 'google'"
              v-model="mapType"
              float-label="Karten Art"
              :options="mapTypeSelection"
      />
      &nbsp&nbsp
      <q-toggle v-model="showAll" color="blue" label="Show All" @input="showChanged(showAll)" />

    </div>
    <hr>
    <div class="row">
      <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3"  v-for="box in boxes" :key="box.id" >
              <q-checkbox v-model="box.active"   :label="box.label" @input="polyChanged(box)" />
      </div>
    </div>
    <hr>
    
    
      <div id="map" class="map"></div>  
    </div>
  </q-page>
</template>
<script>
import axios from 'axios'
import qs from 'qs'
import Vue from 'vue'
//we do not neeed it yet but will need it later
//import {eventBus} from '../main'

export default {
  name: 'PageGeoRegions',
  components: {
    
  },
  data: function () {
    return {
      map: null,
      tileLayer: null,
      mapType: 'satellite',
      mapProvider: 'google',
      geoRegions: [],
      boxes:[],
      showAll: true,
      form: {
        SessionId: null,
        action: 'GeoRegions'
      },
      mapTypeSelection: [       
        {
          label: 'Satelliten Ansicht',
          value: 'satellite'
        },
        {
          label: 'Strassenkarte',
          value: 'roadmap'
        },
      ],
      mapProviderSelection: [
        {
          label: 'Google',
          value: 'google'
        },
        {
          label: 'Open Street View',
          value: 'osm'
        },
        {
          label: 'Open Street View Mapnik',
          value: 'osm-mapnik'
        },
        {
          label: 'Esri World Street Map',
          value: 'esri'
        },
        {
          label: 'Open Sea Map Overlay',
          value: 'openseamap'
        },
        {
          label: 'Swisstopo',
          value: 'swiss'
        },
        {
          label: 'Swissimage',
          value: 'swissimage'
        },
      ],
    }
  },
  methods: {
    initMap() {
      this.map = L.map('map').setView([47.31, 8.592], 15);
      //this.tileLayer = L.gridLayer.googleMutant({ type: this.mapType })

      var url = 'https://wmts20.geo.admin.ch/1.0.0/ch.swisstopo.swissimage/default/current/3857/{z}/{x}/{y}.jpeg'
      var opt = {
        maxZoom: 20,
        attribution: 'insafety.ch | swisstopo'
      }

      this.tileLayer = L.tileLayer.wms(url, opt)

      this.tileLayer.addTo(this.map)
      //document.getElementsByClassName( 'leaflet-control-attribution' )[0].style.display = 'none'
    },
    loadGeoRegions(){
      this.form.SessionId = this.$store.state.session.SessionId
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
           var self = this;
          this.submitting = false
          console.log(response.data)
          console.log(response)
          if(response.status == 200){    
              response.data.forEach(GeoRegion => {
                  console.log('GeoRegion: ' + GeoRegion.Description)
                  //Deconstruct poly
                  var pl = GeoRegion.poly.substr(10, GeoRegion.poly.length - 12)
                  var gpl = pl.split(',')
                  var cords = [];
                  gpl.forEach(gp => {
                    //console.log('     gp: ' + gp)
                    var gpls = gp.trim().split(' ')
                    var LatLong = {Lat: gpls[1], Long: gpls[0]}
                    console.log( gpls[1] + ', ' + gpls[0]   )
                    var cord = [
                      gpls[1],
                      gpls[0]
                    ]
                    cords.push(cord)                 
                  })
                  //Insert the Poligon now now now!
                  var poligon = L.polygon(cords).bindTooltip(GeoRegion.Description,{permanent: true, direction:"top", opacity: 0.6}).setStyle({weight: 2})
                  poligon.name = GeoRegion.Description
                  poligon.IdGeoRegion = GeoRegion.IdGeoRegion
                  this.geoRegions.push(poligon)
                  poligon.addTo(this.map) 
                  var symb = ' ha'
                  if(GeoRegion.IdParent == null)
                    symb = ' ha*'
                  
                  this.boxes.push({id: GeoRegion.IdGeoRegion,label: GeoRegion.Description + ', ' + round(GeoRegion.SquareMeter / 10000, 4) + symb, active: true, leafletObject: poligon},)
                        
              });
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
          this.submitting = false
          if(e.response.status == 403){
              //this.errors.push(this.translate('LoginError'))
              this.$q.notify('Something Wrong.')

          }
          console.log(e)
      })

    },
    polyChanged (box){
        //alert('changed id: ' + box.id + ' active: ' + box.active)
        if(box.active){
          box.leafletObject.addTo(this.map)
        }
        else{
          box.leafletObject.removeFrom(this.map)
        }
    },
    showChanged (show){    
      this.boxes.forEach(box => {
          if(!show){
            box.active = false
            box.leafletObject.removeFrom(this.map)
          }
          else{
            box.active = true
            box.leafletObject.addTo(this.map)
          }     
      });  
    },
    resetMap(){
        this.map.remove()
        this.map = L.map('map').setView([47.31, 8.592], 15);
        this.loadGeoRegions()
    }
  },
  created () {
    
  },
  mounted() {
    this.initMap()
    this.loadGeoRegions()
  },
  watch: {
    mapType: function (val) {
      this.tileLayer = L.gridLayer.googleMutant({ type: this.mapType })
      this.tileLayer.addTo(this.map)
    },
    mapProvider: function (val) {
      this.tileLayer = null

      if(this.mapProvider == 'google'){
        this.resetMap()
        this.tileLayer = L.gridLayer.googleMutant({ type: this.mapType })
      }

      if(this.mapProvider == 'osm'){
        this.resetMap()
        this.tileLayer = L.tileLayer(
          'https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}.png',
          {
            maxZoom: 18,
          }
        );
      }

     if(this.mapProvider == 'osm-mapnik'){
       this.resetMap()
      this.tileLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      });
     }

      if(this.mapProvider == 'esri'){
        this.resetMap()
          this.tileLayer = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', {
            attribution: 'Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012'
          });  
      }

      if(this.mapProvider == 'openseamap'){
        this.resetMap()
        this.tileLayer = L.tileLayer('https://tiles.openseamap.org/seamark/{z}/{x}/{y}.png', {
          attribution: 'Map data: &copy; <a href="http://www.openseamap.org">OpenSeaMap</a> contributors'
        });
      }

      if(this.mapProvider == 'swiss'){        
        this.resetMap()
        var url = 'https://wmts20.geo.admin.ch/1.0.0/ch.swisstopo.pixelkarte-farbe/default/current/3857/{z}/{x}/{y}.jpeg'
        this.tileLayer = L.tileLayer.wms(url)
      }

      if(this.mapProvider == 'swissimage'){
        this.resetMap()

        var url = 'https://wmts20.geo.admin.ch/1.0.0/ch.swisstopo.swissimage/default/current/3857/{z}/{x}/{y}.jpeg'
        var opt = {
          maxZoom: 20,
          attribution: 'insafety.ch | swisstopo'
        }
        this.tileLayer = L.tileLayer.wms(url, opt)

      }


      this.tileLayer.addTo(this.map);
    },    
  },
}
function round(value, decimals) {
  return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
}

</script>
<style scoped>
.map{
  padding: 20px;
  height: calc(100vh - 280px);
  width: 100%;
}
.page{
  padding: 5px;
}
</style>
